"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const input_1 = __importDefault(require("../input"));
//TODO: remove below lines when btn component is available
const input_styles_1 = require("../input.styles");
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const AdrillaInput = (props) => {
    //TODO: use button component when available
    const { theme, currentMode } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = theme.colors[currentMode];
    const submitBtn = (react_1.default.createElement(input_styles_1.SubmitButton, { theme: theme, colors: colors, onClick: props.onBtnClick },
        react_1.default.createElement(input_styles_1.RightArrowIcon, null)));
    const leftElement = react_1.default.createElement(input_styles_1.CarIcon, null);
    return (react_1.default.createElement(input_1.default, Object.assign({}, props, { value: props.value.toUpperCase(), style: { height: '60px' }, leftElement: leftElement, rightElement: submitBtn, isAdrillaInput: true })));
};
exports.default = AdrillaInput;
//# sourceMappingURL=home-input.js.map